import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';


function Imprint() {

const { t } = useTranslation();


  return (
    <>


<div className="content-section-homepage">

  <div className="grid-content-item col-six center"><h1>{t('legal_info')}</h1></div>
<div className="grid-content-item col-six"><h2>{t('a_brand_of')}:<br></br></h2>

<p>
	 Appadise UG<br></br>
Sierichstr. 168<br></br>
22299 Hamburg<br></br>
{t('germany')}<br></br>
<br></br>
{t('email')}: mike@r2d2.plus<br></br>
<br></br>
{t('registry_court')}: {t('district_court')} {t('hamburg')}, HRB 183319<br></br>
{t('ceo')}: Marc Schmitt<br></br>

<br></br>
<br></br><br></br>

<h1>{t('legal_notice')}</h1>
<h2>{t('copyright')}</h2>
{t('copyright_text')}
<br></br><br></br>
© {t('copyright')} Appadise UG, 2025
<br></br><br></br>
<h2>{t('links')}</h2>
{t('links_text')}
<br></br><br></br>
<h2>{t('online_dispute_resolution')}</h2>
{t('online_dispute_resolution_text')}<br></br>
<br></br>
{t('online_dispute_resolution_no')}
</p>
</div>

      </div>

</>
);
}

export default Imprint;



